import React from 'react';
import styles from './FotoButton.module.css';
import { CommonButton } from '_components';

export class FotoButton extends React.Component {
    render() {
        let cls;
        switch (this.props.size) {
            case "extra-small":
                cls = styles.button_extra_small;
                break;
            case "smaller":
                cls = styles.button_smaller;
                break;
            case "small":
                cls = styles.button_small;
                break;
            case "medium":
                cls = styles.button_medium;
                break;
            case "large":
                cls = styles.button_large;
                break;
            default:
                cls = styles.button_small;
                break;
        }

        cls = styles.button + ' ' + cls;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'FOTO'} onClick={this.props.onClick} size={this.props.size} className={cls} >FOTO</CommonButton>
        );



    }
}


